module.exports = __webpack_public_path__ + "img/share-copy-normal.2d42698b.png";